import { gql } from '@apollo/client';
import { graphQLVehiclesGroupToVehicleGroup, graphQLVehiclesGroupToVehicleGroupWithPath } from './VehicleGroupTransformer';

import type { NewVehicleGroup, VehicleGroup, VehicleGroupWithPath } from '@cobliteam/common-types';

import type { MutationCreateVehiclesGroupArgs, MutationUpdateVehiclesGroupArgs, VehiclesGroup, VehiclesGroupInput } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLVehicleGroupsRequester {
  public getVehicleGroups = (groupIds?: string[]): Promise<VehicleGroup[]> => {
    return graphQLRequester
      .query<{ vehicleGroups: VehiclesGroup[] }>({
        query: gql`
          query vehicleGroups($groupIds: [String]) {
            vehicleGroups(groupIds: $groupIds) {
              id
              name
              createdAt
              updatedAt
              creatorId
              vehicles {
                id
              }
            }
          }
        `,
        variables: {
          groupIds: groupIds,
        },
      })
      .then((graphQlResponse) => graphQlResponse.vehicleGroups.map(graphQLVehiclesGroupToVehicleGroup));
  };

  public getVehicleGroupsWithPaths = (): Promise<VehicleGroupWithPath[]> => {
    return graphQLRequester
      .query<{ vehicleGroups: VehiclesGroup[] }>({
        query: gql`
          query vehicleGroupsWithPath {
            vehicleGroups {
              id
              name
              path
            }
          }
        `,
      })
      .then((graphQlResponse) => graphQlResponse.vehicleGroups.map(graphQLVehiclesGroupToVehicleGroupWithPath));
  };

  public createVehicleGroup = (newVehicleGroup: NewVehicleGroup): Promise<void> => {
    const vehicleGroupInput: VehiclesGroupInput = {
      name: newVehicleGroup.name,
      vehicleIds: newVehicleGroup.vehicleIds || [],
    };

    return graphQLRequester
      .mutate<{ createVehiclesGroup: VehiclesGroup }, MutationCreateVehiclesGroupArgs>({
        mutation: gql`
          mutation CreateVehiclesGroup($input: VehiclesGroupInput!) {
            createVehiclesGroup(input: $input) {
              id
              name
              fleetId
              createdAt
              updatedAt
              creatorId
              vehicles {
                id
              }
            }
          }
        `,
        variables: {
          input: vehicleGroupInput,
        },
      })
      .then();
  };

  public updateVehicleGroup = (vehicleGroup: VehicleGroup): Promise<void> => {
    const vehicleGroupInput: VehiclesGroupInput = {
      name: vehicleGroup.name,
      vehicleIds: vehicleGroup.vehicleIds || [],
    };

    return graphQLRequester
      .mutate<{ updateVehiclesGroup: VehiclesGroup }, MutationUpdateVehiclesGroupArgs>({
        mutation: gql`
          mutation UpdateVehiclesGroup($id: ID!, $input: VehiclesGroupInput!) {
            updateVehiclesGroup(id: $id, input: $input) {
              id
              name
              fleetId
              createdAt
              updatedAt
              creatorId
              vehicles {
                id
              }
            }
          }
        `,
        variables: {
          id: vehicleGroup.id,
          input: vehicleGroupInput,
        },
      })
      .then();
  };
}
